export const mockData = {
  services: [
    {
      icon: 'Code2',
      title: 'Custom WebApps',
      description: 'Maßgeschneiderte Webanwendungen, die exakt auf Ihre Geschäftsprozesse zugeschnitten sind. Von der Planung bis zur Umsetzung – wir entwickeln die perfekte Lösung für Ihr Unternehmen.'
    },
    {
      icon: 'Smartphone',
      title: 'Mobile-First Design',
      description: 'Responsive Anwendungen, die auf allen Geräten perfekt funktionieren. Ihre Kunden erreichen Sie überall – egal ob Desktop, Tablet oder Smartphone.'
    },
    {
      icon: 'Zap',
      title: 'Prozessoptimierung',
      description: 'Automatisieren Sie wiederkehrende Aufgaben und optimieren Sie Ihre Arbeitsabläufe. Wir analysieren Ihre Prozesse und entwickeln intelligente Lösungen zur Effizienzsteigerung.'
    },
    {
      icon: 'Users',
      title: 'Handwerksbetriebe',
      description: 'Spezielle Lösungen für Handwerksbetriebe: Werkzeugverwaltung, Fahrzeugtracking, Auftragsverwaltung und mehr. Digital durchstarten mit AppPilot.'
    },
    {
      icon: 'Shield',
      title: 'Datenschutz & Sicherheit',
      description: 'DSGVO-konform und sicher. Alle Daten werden ausschließlich auf Servern in Deutschland gespeichert. Ihre Sicherheit hat bei uns höchste Priorität.'
    },
    {
      icon: 'Server',
      title: 'Wartung & Support',
      description: 'Auch nach dem Launch sind wir für Sie da. Regelmäßige Updates, technischer Support und kontinuierliche Optimierung – wir sorgen für den reibungslosen Betrieb Ihrer Anwendung.'
    }
  ],
  features: [
    {
      icon: 'Shield',
      title: 'DSGVO-konform',
      description: 'Höchste Datenschutzstandards und vollständige DSGVO-Konformität. Ihre Daten sind bei uns in sicheren Händen.'
    },
    {
      icon: 'Server',
      title: 'Server in Deutschland',
      description: 'Alle Server stehen ausschließlich in Deutschland. Keine Datenübertragung ins Ausland, volle Kontrolle über Ihre Daten.'
    },
    {
      icon: 'Zap',
      title: 'Schnelle Umsetzung',
      description: 'Effiziente Entwicklungsprozesse bedeuten kurze Projektlaufzeiten. Von der Idee zur fertigen Anwendung in kürzester Zeit.'
    },
    {
      icon: 'CheckCircle2',
      title: 'Kostengünstig',
      description: 'Faire Preise für kleine und mittelständische Unternehmen. Transparente Kostenstruktur ohne versteckte Gebühren.'
    }
  ],
  portfolio: [
    {
      title: 'ToolTrack',
      description: 'Eine moderne Web-App zur Verwaltung und Nachverfolgung von Werkzeugen in Unternehmensfahrzeugen. Entwickelt für Handwerksbetriebe zur optimalen Organisation ihres Werkzeugbestands.',
      image: 'https://images.unsplash.com/photo-1547658719-da2b51169166?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHx3ZWIlMjBkZXZlbG9wbWVudHxlbnwwfHx8fDE3NjQzMTYzNTh8MA&ixlib=rb-4.1.0&q=85',
      tags: ['WebApp', 'Handwerk', 'Tracking']
    },
    {
      title: 'Weitere Projekte folgen',
      description: 'Wir arbeiten kontinuierlich an innovativen Lösungen für unsere Kunden. Kontaktieren Sie uns, um mehr über unsere aktuellen Projekte zu erfahren.',
      image: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHx3ZWIlMjBkZXZlbG9wbWVudHxlbnwwfHx8fDE3NjQzMTYzNTh8MA&ixlib=rb-4.1.0&q=85',
      tags: ['Coming Soon']
    }
  ]
};